import { render, staticRenderFns } from "./GatewaysList.vue?vue&type=template&id=561e2a50&scoped=true&"
import script from "./GatewaysList.vue?vue&type=script&lang=ts&"
export * from "./GatewaysList.vue?vue&type=script&lang=ts&"
import style0 from "./GatewaysList.vue?vue&type=style&index=0&id=561e2a50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561e2a50",
  null
  
)

export default component.exports